import React from "react";
import "./BrandShowcase.css";

import amazon from "../../resources/assets/logos/AmazonLogo.png";
import shopee from "../../resources/assets/logos/ShopeeLogo.png";
import walmart from "../../resources/assets/logos/WalmartLogo.png";
import lazada from "../../resources/assets/logos/LazadaLogo.png";

// Add more logos as needed
const logos = [amazon, shopee, walmart, lazada];

const BrandShowcase = () => {
  // Repeat logos enough times to avoid whitespace during scroll
  const repeatedLogos = Array(4).fill(logos).flat(); // repeat logos 4x

  return (
    <section className="brand-showcase">
      <div className="brand-content">
        <h2>Enabling success with our trusted partners.</h2>
        <p>
          Join hundreds of businesses scaling globally through effortless collaboration, tailored export solutions, and unwavering support that turns quality craftsmanship into lasting partnerships.
        </p>
      </div>

      <div className="marquee-container">
        <div className="marquee-track">
          {repeatedLogos.map((logo, index) => (
            <img src={logo} alt={`brand-${index}`} key={index} className="logo-item" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandShowcase;
